export const BOOK_NAV_REQUESTED = 'book:navigationRequested';
export const BOOK_SELECTION_CANCELLED = 'book:selectionCancelled';
export const BOOK_SELECTION_MADE = 'book:selectionMade';
export const BOOK_SELECTION_WITH_POSITION = 'book:selectionWithPosition';
export const BOOK_PAGE_BREAK = 'book:pagebreak';
export const BOOK_CLICK = 'book:click';
export const BOOK_TOUCH_START = 'book:touchstart';
export const BOOK_TOUCH_END = 'book:touchend';
export const BOOK_TOUCH_MOVE = 'book:touchmove';
export const BOOK_KEY_UP = 'book:keyup';
export const BOOK_KEY_DOWN = 'book:keydown';
export const BOOK_KEY_PRESS = 'book:keypress';
export const BOOK_MOUSE_MOVE = 'book:mousemove';
export const BOOK_MOUSE_WHEEL = 'book:mousewheel';
export const HIGHLIGHT_CLICK = 'highlight:click';
export const HIGHLIGHT_MOUSE_OUT = 'highlight:mouseout';
export const HIGHLIGHT_MOUSE_OVER = 'highlight:mouseover';
export const NOTE_ICON_CLICK = 'noteicon:click';
export const PAGE_READY = 'page:ready';
export const PAGE_LOAD = 'page:load';
export const PAGE_UNLOAD = 'page:unload';
export const PAGE_RESIZE = 'page:resize';
export const PAGE_SCROLL = 'page:scroll';
export const PAGE_TRANSFORM = 'page:transform';
export const USER_SIGNOUT = 'user:signout';
export const TTS_V2_STATUS = 'tts-v2:status';
